export const StatusConstant = [
    { id: 10, statusName: 'Open' },
    { id: 3, statusName: 'In Progress' },
    { id: 11, statusName: 'Closed' }
];


export const StatusConstantForApproval = [
    { id: 3, statusName: 'Approved' },
    { id: 1, statusName: 'Pending' },
    { id: 4, statusName: 'Rejected' }
];

